import { useEffect } from "react";
import { startSyncEngine } from "./syncEngine";
import { OfflineDispatch } from "./counters";

/**
 * Mounts the offline sync engine, and re-mounts it whenever the signed-in user
 * changes.
 *
 * The re-mount is the point. `startSyncEngine` skips its boot work without a live
 * session, and `App` — which also serves /login — never unmounts. So a cold start
 * at the login page used to disable the boot flush and the staleness check for the
 * rest of that page's life: an in-app login left queued field work and a stale
 * snapshot waiting for a manual reload.
 *
 * Keyed on the user *id*, never the user object: `getUser()` is polled from
 * several pages and returns a fresh object each time, which would restart the
 * engine on every poll. The id also changes on impersonation, where restarting is
 * exactly what we want.
 */
export const useOfflineSyncEngine = (
  dispatch: OfflineDispatch,
  sessionUserId?: number | null
): void => {
  useEffect(() => startSyncEngine(dispatch), [dispatch, sessionUserId]);
};
